import { Link } from 'react-router-dom';
import Icons from '../../../../../common/widgets/Icons';
import { Image } from '../../../models/Discover';

interface ICardProps {
  readonly colorClass: 'green-card' | 'blue-card' | 'red-card';
  readonly image: Image;
  readonly title: string;
  readonly actionName: string;
  readonly link: string;
}

const PromoCard = (props: ICardProps) => {
  const { colorClass, image, title, actionName, link } = props;

  return (
    <div className={`mkt-card ${colorClass} discover-promo`}>
      <div className="mkt-card-img w-fixed">
        <img src={image.img} alt={image.alt} />
      </div>
      <div className="mkt-card-copy">
        <h3 className="mkt-card-title">{title}</h3>
        <div className="mkt-card-action">
          <Link className="btn-link" to={link}>
            <span className="btn-icon">
              <Icons.ArrowButton />
            </span>
            <span className="btn-text">{actionName}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PromoCard;
